import { render, staticRenderFns } from "./MessageControl.vue?vue&type=template&id=3fc8a5af&"
import script from "./MessageControl.vue?vue&type=script&lang=ts&"
export * from "./MessageControl.vue?vue&type=script&lang=ts&"
import style0 from "./MessageControl.vue?vue&type=style&index=0&id=3fc8a5af&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports